import { CLASSNAME_HIDDEN } from '@vfde-brix/ws10/styles';

/**
 * Show HTMLElement (or hide with show=false)
 * @param {HTMLElement | null | string} elem - element or id of element to toggle
 * @param {unknown} shouldShow - flag to show or hide element
 */
export const setElementVisibility = (elem: HTMLElement | null | string, shouldShow: unknown) => {
    const element = elem instanceof HTMLElement ? elem : document.getElementById(elem || '');

    element?.classList.toggle(CLASSNAME_HIDDEN, !shouldShow);
};

/**
 * Show HTMLElements (or hide with show=false)
 * @param {(HTMLElement | null | string)[]} elements - array of elements or ids of elements to toggle
 * @param {unknown} shouldShow - flag to show or hide element
 */
export const setElementsVisibility = (elements: (HTMLElement | null | string)[], shouldShow: unknown) => {
    elements.forEach(component => setElementVisibility(component, shouldShow));
};
